/**
 * Parses an ISO 8601 duration string (e.g. "PT40M", "PT1H30M", "PT1H")
 * and returns a human-readable string (e.g. "40 mins", "1 hr 30 mins", "1 hr").
 * Falls back to returning the original value if it isn't an ISO duration.
 */
export function formatDuration(value: string | null | undefined): string | null | undefined {
  if (!value) return value;

  const match = value.match(/^PT(?:(\d+)H)?(?:(\d+)M)?$/);
  if (!match) return value;

  const hours = match[1] ? parseInt(match[1], 10) : 0;
  const mins = match[2] ? parseInt(match[2], 10) : 0;

  if (hours && mins) return `${hours} hr ${mins} mins`;
  if (hours) return `${hours} hr`;
  if (mins) return `${mins} mins`;

  return value;
}
